// removed by extract-text-webpack-plugin
module.exports = {"divider":"index_pMpLiqm"};


//////////////////
// WEBPACK FOOTER
// ./src/component/divider/index.css
// module id = 955
// module chunks = 0